import dynamic from 'next/dynamic'
import { PropertyRecordsIcon } from 'src/components/insights/icons/property-records'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/property-taxes.png'

const PropertyTaxes = dynamic(() => import('src/components/insights/property-records/property-taxes'), { ssr: false })

export const PropertyTaxesWidget: InsightBuilderWidget = {
  id: 'property-taxes',
  name: 'Property Taxes',
  type: 'Property Records',
  icon: PropertyRecordsIcon,
  component: PropertyTaxes,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'entry',
}
